import { FC } from "react";
import Chip from "@mui/material/Chip";
import { Box, Stack } from "@mui/material";
import { IconByResourceType } from "../../../IconByResourceType";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { ResourceType } from "@/services/cloudchipr.api";
import { getResourceTypeName } from "@/utils/helpers/resources/getResourceTypeName";
import { CopyIconButton } from "@/components/common/CopyIconButton";
import { useHover } from "@/utils/hooks/useHover.hook";

interface ResourceServiceCellProps {
  service: ResourceType;
  inPopover?: boolean;
}

export const ResourceServiceCell: FC<ResourceServiceCellProps> = ({
  service,
  inPopover,
}) => {
  const { ref, hovered } = useHover();

  const name = getResourceTypeName(service, {
    type: "long",
    singular: true,
  });

  return (
    <Chip
      ref={ref}
      sx={chipStyles}
      avatar={
        <Box sx={{ filter: "grayscale(1)" }}>
          <IconByResourceType resourceType={service} />
        </Box>
      }
      label={
        <Stack direction="row" spacing={0.5} alignItems="center">
          <TypographyWithTooltip variant="body2" title={name} />

          {(hovered || inPopover) && <CopyIconButton data={name} />}
        </Stack>
      }
    />
  );
};

const chipStyles = {
  px: 0.5,
  borderRadius: 2,
  overflow: "hidden",
};
